import { useEffect } from 'react';
import { useLoading } from '../../../../components/LoadingProvider';
import useAuth from '../../../../hooks/useAuth';

export default function PrescriptionPage() {
    const { setIsLoading } = useLoading();
    const { user, isAuthenticated, userRole } = useAuth({ redirectPath: '/login', allowedRoles: ['patient'] });

    useEffect(() => {
        document.title = 'Varosa - Patient Prescriptions';
        setIsLoading(false);
    }, []);

    return (
        <>
            <div className="container py-5 login-container">
                <div className="row g-3">
                    <div className="col-9">
                        <h2 className="mb-4">My Prescriptions</h2>
                    </div>
                    <div className="col-3 text-end">
                        <button onClick={() => window.history.go(-1)} className="btn btn-primary">Back</button>
                    </div>
                </div>
                <div className="row g-3">
                    <div className="col-12">
                        <p className="text-muted">Coming Soon</p>
                    </div>
                </div>
            </div>
        </>
    );
}